export enum IssuersRoutes {
  CreateOne = 'create-one',
  Search = 'search',
  UpdateOne = 'update-one',
}
